import { createAvatarWrapper } from '@/modules/misc/common/navbar/components/avatar';
import { createSwitchAccountButtons, switchAccounts } from '@/modules/misc/common/navbar/components/navbarLinks';
import { deleteChildNodes } from '@/modules/misc/common/navbar/utils/deleteChildNodes';

export function createVCAvatarDropdown({ links, user }) {
  const avatarWrapper = document.querySelector('#avatar-wrapper');

  if (!avatarWrapper) {
    return;
  }

  deleteChildNodes(avatarWrapper);

  // TM-5692
  if (window.matchMedia('(min-width: 1280px)').matches) {
    links = links.filter(link => link.name !== 'managers' && link.name !== 'menus');
    if ((Array.isArray(user.moduleAccess) && user.moduleAccess.includes('PROPOSALS'))) {
      links.unshift({
        name: 'menus',
        url: '/venue-cabinet/menus',
        label: 'Settings',
        options: {
          icon: 'settings',
          tracking: {
            section: 'navbar_manager',
            element: 'settings',
          },
        },
      });
    } else {
      links.unshift({
        name: 'managers',
        url: '/venue-cabinet/venues-managers',
        label: 'Settings',
        options: {
          icon: 'settings',
          tracking: {
            section: 'navbar_manager',
            element: 'settings',
          },
        },
      });
    }
  }

  if (links.length) {
    const avatarPlaceholder = document.querySelector('.js-avatar-menu-placeholder');

    if (avatarPlaceholder) {
      avatarPlaceholder.style.display = 'none';
    }

    avatarWrapper.appendChild(createAvatarWrapper({
      className: 'ds-header__navbar__avatar',
      user,
      links,
      dotAllowed: false,
      showDot: false,
    }));
  }

  if (user?.canSwitchAccounts) {
    const dropdown = document.querySelector('.ds-header__navbar__avatar__dropdown');
    dropdown.appendChild(createSwitchAccountButtons({ user }));
    dropdown.style.paddingBottom = '0px';

    if (user.type === 'user') {
      document.getElementById('switchToManagerAccount').addEventListener('click', switchAccounts);
    } else if (user.type === 'manager') {
      document.getElementById('switchToUserAccount').addEventListener('click', switchAccounts);
    }
  }
}
